// Copyright ©️ 2025 eVolve MEP, LLC

import { strongEntries } from './strongEntries';

/** Returns `Omit<T, K>`. Prefer `omit` when possible. */
export const weakOmit = <T extends object, K extends string | number | symbol>(
  obj: T,
  keys: readonly K[],
): Omit<T, K> => Object.fromEntries(strongEntries(obj).filter(([k]) => !keys.includes(k as keyof T & K))) as Omit<T, K>;

/** Returns `StrongOmit<T, K>` */
export const omit = <T extends object, K extends keyof T>(obj: T, keys: readonly K[]): Omit<T, K> =>
  weakOmit(obj, keys) as Omit<T, K>;
